var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27748 2.92609L1.91572 12.251C1.59646 12.8066 1.99761 13.4999 2.6382 13.4999H13.3622C14.0023 13.4999 14.4038 12.8064 14.0847 12.251L8.72278 2.92585C8.72277 2.92583 8.72279 2.92587 8.72278 2.92585C8.40254 2.36917 7.59872 2.36881 7.27748 2.92609ZM6.41092 2.42702C7.11646 1.20195 8.88456 1.20144 9.58962 2.42727L14.9517 11.7527C15.6538 12.9746 14.7714 14.4999 13.3622 14.4999H2.6382C1.22813 14.4999 0.346611 12.9745 1.04868 11.7528L6.41092 2.42702ZM8.0002 5.49989C8.27634 5.49989 8.5002 5.72375 8.5002 5.99989V8.66656C8.5002 8.9427 8.27634 9.16656 8.0002 9.16656C7.72406 9.16656 7.5002 8.9427 7.5002 8.66656V5.99989C7.5002 5.72375 7.72406 5.49989 8.0002 5.49989Z",
    fill: "#E30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34302 10.9628C8.54734 11.1486 8.56239 11.4648 8.37663 11.6691L8.36997 11.6764C8.18421 11.8808 7.86798 11.8958 7.66366 11.7101C7.45933 11.5243 7.44428 11.2081 7.63004 11.0038L7.63671 10.9964C7.82247 10.7921 8.13869 10.777 8.34302 10.9628Z",
    fill: "#E30613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.caa35378855ad9415f5164f99f920416.svg";
export { ForwardRef as ReactComponent };